var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_688_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85084 17.7C10.6082 19.4574 13.4574 19.4574 15.2148 17.7L15.2149 17.7L18.4269 14.488C19.0228 13.9125 19.0393 12.9629 18.4637 12.367C17.8882 11.7711 16.9386 11.7546 16.3427 12.3301C16.3302 12.3422 16.3179 12.3545 16.3059 12.367L13.5229 15.149L13.4999 1.5C13.4999 0.671578 12.8283 0 11.9999 0C11.1714 0 10.4999 0.671578 10.4999 1.5L10.5209 15.127L7.75987 12.366C7.164 11.7905 6.2144 11.807 5.63887 12.4028C5.07745 12.9841 5.07745 13.9057 5.63887 14.487L8.85084 17.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.5C21.6716 14.5 21 15.1716 21 16V20.591C20.9994 20.8166 20.8167 20.9994 20.591 21H3.40898C3.18333 20.9994 3.00052 20.8166 3 20.591V16C3 15.1716 2.32842 14.5 1.5 14.5C0.671578 14.5 0 15.1716 0 16V20.591C0.00220312 22.4728 1.52719 23.9978 3.40898 24H20.591C22.4728 23.9978 23.9977 22.4728 24 20.591V16C24 15.1716 23.3284 14.5 22.5 14.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_688_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.d1793910db56dcc8786d132204741386.svg";
export { ForwardRef as ReactComponent };